import axios, { AxiosResponse } from "axios";
import { API_URL } from "./apiUrl";
import fileDownload from "js-file-download";
import AuthService from "src/components/modules/auth/redux/AuthService";

export default async function DownloadFile(url0, url, outputFileName) {
  const user =
    AuthService.GetCurrentUser() != null ? AuthService.GetCurrentUser() : null;

  var responseEntity;
  await axios
    .get(url0.concat(url), {
      headers: {
        Authorization: "Bearer " + user?.token + "",
        sessionGuid: user?.userData?.sessionGuid,
        "Content-Disposition": "attachment; filename=template.xlsx",
      },
      responseType: "arraybuffer",
    })
    .then(function (response) {
      //handle success
     
      responseEntity = response?.data;
      // const outputFilename = `ProductList-2022-05-05.xlsx`;
      // fileDownload(response.data, outputFilename);
      // If you want to download file automatically using link attribute.
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFileName);
      document.body.appendChild(link);
      link.click();
    })
    .catch(function (response) {
      //handle error
    });
  return responseEntity;
}
